import { FormattedMessage, useIntl } from "react-intl";
import {
  ActionBar,
  ActionBarButtons,
  CreateActionButton,
  Loader,
  url,
  userGroupShape,
  useApi,
  Column,
  Container,
  Row,
  List,
  Clue,
  ButtonGroup,
} from "lcm-iot-commons";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import UserGroupItem from "./UserGroupItem";

export default function UserGroups() {
  const api = useApi();
  const intl = useIntl();

  const parameters = { order_by: "name" };
  const {
    data,
    isInitialLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = api.get.useInfiniteQuery("/usergroups", parameters, {
    // @ts-expect-error TS(2322) FIXME: Type '(response: InfiniteData<PaginatedResponse>) ... Remove this comment to see the full error message
    select: (response) => ({
      usergroups: response.pages.flatMap(
        (page) => (page as $TSFixMe).usergroups,
      ),
      totalCount: (response.pages[0]?.pagination as $TSFixMe)?.total_count || 0,
    }),
  });

  const isLoading = isInitialLoading || isFetchingNextPage;
  const userGroups = (data as $TSFixMe)?.usergroups;
  const totalCount = (data as $TSFixMe)?.totalCount;
  const userGroupsCount = totalCount > 0 ? totalCount : null;

  const removeUserGroup = () => refetch();

  const renderUserGroups = () =>
    userGroups.map((item: userGroupShape) => (
      <UserGroupItem
        key={item.id}
        usergroup={item}
        onUserGroupRemoved={removeUserGroup}
      />
    ));

  const badge = isLoading ? (
    <span className="loading">
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  ) : (
    userGroupsCount
  );

  const actionBarButtons = (
    <ActionBarButtons>
      <CreateActionButton
        // @ts-expect-error TS(2322) FIXME: Type '{ disabled: boolean; target: string; }' is not... Remove this comment to see the full error message
        id="create-usergroup-button"
        disabled={isLoading}
        target="/usergroups/create"
      />
    </ActionBarButtons>
  );
  const noUserGroupsFound =
    !isLoading && totalCount === 0 ? (
      // @ts-expect-error TS(2322) FIXME: Type '{ children: Element; id: string; title: stri... Remove this comment to see the full error message
      <Clue
        id="no-usergroups-found"
        title={intl.formatMessage({ id: "usergroups.no_usergroups_found" })}
        details={intl.formatMessage({
          id: "usergroups.no_usergroups_found.ask_create",
        })}
        className="notification"
        highlighted
      >
        <ButtonGroup>
          <Link className="btn btn-primary" to={url("/usergroups/create")}>
            {intl.formatMessage({ id: "button.create_usergroup" })}
          </Link>
        </ButtonGroup>
      </Clue>
    ) : null;

  return (
    <Container>
      <Row>
        <Column>
          <ActionBar>
            <h1 id="usergroups-header">
              <FormattedMessage id="usergroups.header" />
              <span
                id="usergroups-count"
                data-testid="usergroups-count"
                className="badge"
              >
                {badge}
              </span>
            </h1>
            {actionBarButtons}
          </ActionBar>

          {userGroups?.length > 0 && (
            <List id="usergroups-list">
              <InfiniteScroll
                data-testid="usergroup-infinite-scroll"
                initialLoad={false}
                // @ts-expect-error TS(2769) FIXME: No overload matches this call.
                loadMore={fetchNextPage}
                hasMore={hasNextPage && !isFetchingNextPage}
              >
                {renderUserGroups()}
              </InfiniteScroll>
            </List>
          )}
          {noUserGroupsFound}
          <Loader loading={isLoading} />
        </Column>
      </Row>
    </Container>
  );
}
